import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import partial from 'lodash/partial';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {EmptyFunc, SitesByLanguage} from 'utils/DBUtils';
import {RetailerItemFormModes} from '../utils';
import {
  requestRetailerItemImagesAction,
  updateRetailerItemInProgressAction,
  submitCreateRetailerItemAction,
  submitUpdateRetailerItemAction,
  deleteRetailerItemAction,
  endWriteRetailerItemAction
} from '../actions';
import RetailerItemModal from './RetailerItemModal';

const mapStateToProps = state => {
  const {
    selectedLang,
    retailerItemFormMode,
    writingRetailerItem,
    writingRetailerItemResource,
    writeRetailerItemSubmitted,
    createRetailerItemError
  } = state.rewards;

  return {
    lang: selectedLang,
    mode: retailerItemFormMode,
    retailerItem: writingRetailerItemResource,
    isOpen: writingRetailerItem,
    isInFlight: writeRetailerItemSubmitted,
    apiError: createRetailerItemError
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchItemImages: requestRetailerItemImagesAction,
  createRetailerItem: submitCreateRetailerItemAction,
  updateRetailerItem: submitUpdateRetailerItemAction,
  deleteRetailerItem: deleteRetailerItemAction,
  onClose: endWriteRetailerItemAction,
  onValueChanged: (resourcePath, [field], value) => {
    const change = {[field]: value};
    return updateRetailerItemInProgressAction(change);
  }
}, dispatch);

const RetailerItemModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const retailerItemFormSubmitters = {
      [RetailerItemFormModes.Create]: props.createRetailerItem,
      [RetailerItemFormModes.Update]: props.updateRetailerItem
    };

    const formSubmitter = retailerItemFormSubmitters[props.mode] || EmptyFunc;

    return {
      deleteItem: partial(props.deleteRetailerItem, props.lang, props.retailerItem),
      onSubmit: partial(formSubmitter, props.lang, props.retailerItem)
    };
  }),
  setDisplayName('RetailerItemModalContainer')
)(RetailerItemModal);

export default RetailerItemModalContainer;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RetailerItemModal/RetailerItemModalContainer.js